import { msg } from "@lingui/core/macro";
import { Menu } from "@fleet/icons";

import { Button } from "@/components/ui/button";
import { SyncIndicator } from "@/components/sync-indicator";
import { GlobalSearch } from "@/features/search/components/global-search";
import { OrgSwitcher } from "@/features/organizations/components/org-switcher";
import { AppearanceMenu } from "@/components/appearance-menu";
import { useI18n } from "@/providers/i18n-provider";

interface AppHeaderProps {
  onMenuClick: () => void;
  isNavigating: () => boolean;
}

export function AppHeader(props: AppHeaderProps) {
  const { t } = useI18n();

  return (
    <header class="relative flex h-16 items-center justify-between border-b border-border/20 bg-card/5 px-4 backdrop-blur-sm md:px-6">
      {/* Subtle Loading Bar */}
      <div
        class="absolute bottom-[-1px] left-0 h-[2px] bg-accent transition-[width,opacity] duration-500 ease-out z-50"
        style={{
          width: props.isNavigating() ? "70%" : "0%",
          opacity: props.isNavigating() ? "1" : "0",
          "box-shadow": props.isNavigating() ? "0 0 8px var(--accent)" : "none",
        }}
      />
      <div class="flex items-center gap-4 flex-1">
        <Button
          variant="ghost"
          size="icon"
          /* Touch target ≥44px for warehouse operations on mobile/tablet. */
          class="h-11 w-11 lg:hidden text-muted-foreground hover:text-foreground"
          aria-label={t(msg`Open menu`)}
          onClick={props.onMenuClick}
        >
          <Menu class="h-5 w-5" />
        </Button>
        <GlobalSearch />
        {/* Organization switcher (company/supermarket): rescopes all WMS. */}
        <OrgSwitcher />
      </div>
      <div class="flex items-center gap-1">
        {/* Sync / connection indicator — consistent across the app; tap for details. */}
        <SyncIndicator class="mr-1" />
        {/* Single appearance control: color mode, blur, and gallery.
            Previously three buttons for the same family of settings; the two
            vacated slots are for other utilities. */}
        <AppearanceMenu />
      </div>
    </header>
  );
}
